<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.reportCode">
              <a-input :placeholder="$t('label.pleaseEnter', { field: $t('label.reportCode')})" v-model="queryParam.code" />
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.reportName">
              <a-input :placeholder="$t('label.pleaseEnter', { field: $t('label.reportName')})" v-model="queryParam.name" />
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <mtc-button type="primary" @click="searchQuery" icon="search" text="button.search" />
              <mtc-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" text="button.reset" />
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <mtc-button @click="handleAdd" type="primary" icon="plus" text="button.add" />
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            <mtcLangPopover text="button.delete" />
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          <mtcLangPopover text="button.batchOperation" />
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-alert style="margin: 10px 0">
        <template slot="message">
          <a-icon class="anticon ant-alert-icon" theme="filled" type="info-circle" />
          <span style="margin-left: 20px">
          <!-- 已选择 -->
          <mtcLangPopover text="tip.selected" />：
            <!-- 条数 -->
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
            <!-- 单位 -->
          <mtcLangPopover text="tip.term" />
          <mtcLangPopover text="button.clear">
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
          </mtcLangPopover>
        </span>
        </template>
      </a-alert>
      <a-table ref="table"
               size="middle"
               bordered
               rowKey="id"
               :columns="tableColumn"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               @change="handleTableChange">
        <!-- 表头自定义渲染 -->
        <template v-for="(item, index) in tableColumn" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" />
        </template>
        <span slot="action" slot-scope="text, record">
          <mtcLangPopover text="button.edit">
            <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
          </mtcLangPopover>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              <mtcLangPopover text="button.more" />
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="popReportURL(record.id)">
                <mtcLangPopover text="button.configureAddress" />
              </a-menu-item>
              <a-menu-item @click="goPageOnline(record.id)">
                <mtcLangPopover text="button.functionTest" />
              </a-menu-item>
              <a-menu-item>
                 <a-popconfirm :title="$t('tip.isDelete')" @confirm="handleDelete(record.id)">
                   <mtcLangPopover text="button.delete" />
                 </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <!-- 字符串超长截取省略号显示-->
        <span slot="cgrSql" slot-scope="text">
          <j-ellipsis :length="50" :value="text" />
        </span>
      </a-table>
    </div>
    <!-- 表单区域 -->
    <onlCgreportHead-modal ref="modalForm" @ok="modalFormOk"></onlCgreportHead-modal>
    <!-- 提示online报表链接 -->
    <a-modal :visible="visible"
             @cancel="handleCancel">
      <template #title>
        <mtcLangPopover text="modalTitle.reportAccessLink" />
      </template>
      <template slot="footer">
        <mtc-button @click="handleCancel" text="button.close" style="margin-right: 8px;"/>
        <mtc-button type="primary" class="copy-this-text" :data-clipboard-text="reportUrlText" @click="onCopyUrl" text="button.copy" />
      </template>
      <p>{{ reportUrlText }}</p>
    </a-modal>
  </a-card>
</template>

<script>
import OnlCgreportHeadModal from './modules/OnlCgreportHeadModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Clipboard from 'clipboard'
import { getAction } from '@/api/manage'
import { changeLangColumn } from '@/utils/langUtils'

export default {
  name: 'OnlCgreportHeadList',
  mixins: [JeecgListMixin],
  components: {
    OnlCgreportHeadModal,
    Clipboard
  },
  data() {
    return {
      description: '在线报表配置管理页面',
      visible: false,
      reportUrlText: '',
      // 表头
      columns: [
        {
          title: '报表名称',
          language_key: 'tableHeader.reportName',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '编码',
          language_key: 'tableHeader.coding',
          align: 'center',
          dataIndex: 'code'
        },
        {
          title: '查询SQL',
          language_key: 'tableHeader.querySQL',
          align: 'center',
          dataIndex: 'cgrSql',
          scopedSlots: { customRender: 'cgrSql' }
        },
        {
          title: '数据源',
          language_key: 'tableHeader.dataSource',
          align: 'center',
          dataIndex: 'dbSource_dictText'
        },
        {
          title: '创建时间',
          language_key: 'tableHeader.creationTime',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          language_key: 'tableHeader.operate',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/online/cgreport/head/list',
        delete: '/online/cgreport/head/delete',
        deleteBatch: '/online/cgreport/head/deleteBatch',
        getParamsInfo: '/online/cgreport/api/getParamsInfo/'
      }
    }
  },
  computed: {
    tableColumn() {
      return changeLangColumn(this.columns)
    }
  },
  methods: {
    initReportUrlText(id) {
      getAction(this.url.getParamsInfo + id).then((res) => {
        let textUrl = ''
        if (res.success) {
          if (res.result && res.result.length > 0) {
            for (let i of res.result) {
              textUrl += i.paramName + '=${' + i.paramName + '}&'
            }
          }
        } else {
          this.$message.warning(res.message)
        }
        if (textUrl.length > 0) {
          textUrl = textUrl.substring(0, textUrl.length - 1)
          this.reportUrlText = `/online/cgreport/${id}?${textUrl}`
        } else {
          this.reportUrlText = `/online/cgreport/${id}`
        }
      })
    },
    goPageOnline(id) {
      this.$router.push({ path: '/online/cgreport/' + id })
    },
    popReportURL(id) {
      this.visible = true
      this.initReportUrlText(id)
    },
    handleCancel() {
      this.visible = false
      this.reportUrlText = ''
    },
    onCopyUrl() {
      var clipboard = new Clipboard('.copy-this-text')
      clipboard.on('success', () => {
        clipboard.destroy()
        this.$message.success(this.$t('tip.copySuccessfully'))
        this.handleCancel()
      })
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="less" scoped>

.anty-row-operator button {
  margin: 0 5px
}

.ant-btn-danger {
  background-color: #ffffff
}

</style>